import { Injectable } from '@angular/core';
import { GenericTrialInsightsChart } from '../../classes/trial-insights-chart.class';

@Injectable()
export class TrialInsightsFinanceBvaChartChartService extends GenericTrialInsightsChart {}
